"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bdAccountList = bdAccountList;
exports.deleteBdAccount = deleteBdAccount;
exports.editBdAccount = editBdAccount;
exports.updateBdAccountStatus = updateBdAccountStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function bdAccountList(params) {
  return (0, _request.default)({
    url: '/bd/list',
    method: 'get',
    params: params
  });
}
function editBdAccount(data) {
  return (0, _request.default)({
    url: '/bd/edit',
    method: 'post',
    data: data
  });
}
function deleteBdAccount(data) {
  return (0, _request.default)({
    url: '/bd/delete',
    method: 'post',
    data: data
  });
}
function updateBdAccountStatus(data) {
  return (0, _request.default)({
    url: '/bd/updateStatus',
    method: 'post',
    data: data
  });
}